/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/operators/mul.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Multiply two values together. For numeric fields, if either field is multivalued\nthen the result is `null`. For dense_vector operations, both arguments should be dense_vectors. Inequal vector dimensions generate\nnull result.\n',
  params: {
    lhs: 'A numeric value or dense_vector',
    rhs: 'A numeric value or dense_vector',
  },
};

export default docs;
